interface TemplateInterface {
  title: string;
  header: string;
  description: string;
  graphImage: string;
  table: string;
  info: string;
  webFontsStyles?: string;
  hostFontFamily?: string;
}

/* eslint-disable no-restricted-globals */
export const getTemplate = ({
  header,
  title,
  description,
  graphImage,
  table,
  info,
  webFontsStyles = '',
  hostFontFamily = 'Helvetica, Arial, san-serif',
}: TemplateInterface): string => {
  return `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="UTF-8"/>
        <title>${title}</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <style>
          ${webFontsStyles}

          body {
            font-family: Helvetica, Arial, san-serif;
          }

          body.custom-font {
            font-family: ${hostFontFamily}
          }

          .product-name {
            margin: 5px 0px;
            color: #333;
          }

          .product-family {
            color: #333;
            font-size: .9em;
            font-style: italics;
            margin: 5px 0px;
          }

          .graph-img {
            margin: 1em 0;
          }

          .info {
            color: #333;
            background: #f3f2f2;
            padding: 1rem;
            font-size: .85rem;
            margin: 1rem 0;
          }
  
          .meta {
            display: inline-block;
            margin-top: 1rem;
            color: #333;
            font-style: italic;
            font-size: .85rem;
          }

          table {
            margin: 1rem 0;
            border-spacing: 0;
            width: 100%;
            text-align: left; 
            font-size: .6rem;
            color: #333;
          }

          th {
            color: #626469;
            font-size: .7rem;
            padding: 7px 3px;
        
              text-align: left; 
            }
 })
        td {
            border-top: 1px solid #f3f2f2;
            padding: 7px 2px;
          }

          .product-qnt {
            color: #333;
            background-color: #e7e6e6;
            font-size: 0.5rem;
            padding: 1px 3px;
            border-radius: 10.5px;
            margin-left: 0px;
            margin-right: 6px;
            line-height: normal;
            display: inline-block;
            vertical-align: text-bottom;
          }

          .product-id {
            font-weight: bold;
            display: block;
            line-height: 1.2rem;
            margin-right: 8px;
            white-space: nowrap;
          }

          a.product-id {
            color: #42B4E6;
          }

          img {
            max-width: 100%;
          }

          @media screen and (max-width: 400px) {
            .info {
              padding: 10px;
              font-size: .5rem;
            }
          }

          .hidden-print {
            display: none;
          }

          @media print {

            table {
              page-break-inside: avoid;
            }

            img {
              max-height: 5in;
            }

          }

        </style>
      </head>
      <body>
      ${header}
      ${description}
      ${graphImage}
      ${info}
      ${table}
      <a class="meta" href="${location.href}">${location.href}</a>
      <script>
        function supportsFontDisplay() {
          try {
            var styleEl = document.createElement("style");
            styleEl.textContent = "@font-face { font-display: swap; }";
            document.head.appendChild(styleEl);
            var isFontDisplaySupported = styleEl.sheet.cssRules[0].cssText.indexOf("font-display") != -1;
            styleEl.remove();
            return isFontDisplaySupported;
          } catch (e) { 
          }
        }

        if (supportsFontDisplay()) {
          document.body.classList.add("custom-font");
        }
        
        </script>
      </body>
    </html>
  `;
};
/* eslint-enable no-restricted-globals */
